// extracted by mini-css-extract-plugin
export default {"selectedCategoriesContainer":"selectedCategoriesContainer__2i-IP","selectedCategoriesList":"selectedCategoriesList__3UhNf","selectedCategoriesElement":"selectedCategoriesElement__2laOH","removeCatButton":"removeCatButton__2plfk"};
    if(module.hot) {
      // 1713425497952
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  